import angular from 'angular';

import addressInputTemplate from './addressInput.template.html';
import './addressInput.css';

import InlineInput from '../inlineInput/inlineInput';
import InlineLabelGroup from '../inlineLabelGroup/inlineLabelGroup';
import phoneInput from '../phoneInput/phoneInput';
import StateSelector from '../stateSelector/stateSelector';
import validators from '../validators/validators';

export default angular
  .module('csm.ui.addressInput', [
    InlineInput,
    InlineLabelGroup,
    phoneInput,
    StateSelector,
    validators
  ])

  /*****************************************************************************
   * Directive: addressInput
   *
   * Provides a means of managing address/contact information.
   *
   * The following attributes affect this directive:
   *   addressInput     - Bound model object
   *   groupName        - Optional main label group name
   *   contactGroupName - Optional contact label group name when using horizontal
   *                      orientation
   *   excludeFax       - Exclude Fax Input
   *   phone1Label      - Phone 1 label
   *   phone2Label      - Phone 2 label
   *   orientation      - Default: vertical.
   *   requireAddress   - Boolean indication to require address fields.Default=false
   *   requireEmail     - Boolean indication to require email field. Default=false
   *   validatorControl - Optional control object to manage address validation
   *****************************************************************************/
  .directive('addressInput', function (WindowSize) {
    return {
      restrict: 'A',
      scope: {
        address: '=addressInput',
        groupName: '@',
        contactGroupName: '@',
        phone1Label: '@',
        phone2Label: '@',
        orientation: '@',
        validatorControl: '='
      },
      template: addressInputTemplate,
      link: function (scope, element, attr) {
        /** Character Limits */
        scope.MAX_CHARS_ADDRESS = 200;
        scope.MAX_CHARS_CITY = 100;
        scope.MAX_CHARS_EMAIL = 50;

        /** Flag attribute list. */ var mFlagAttributes = [
          'excludeFax',
          'requireAddress',
          'requireEmail'
        ];
        /** Unique group name. */ var mUniqueGroupName =
          'csm_address_' + scope.$id;

        /*-------------------------------------------*/
        /* Label group name getters for each section */
        /*-------------------------------------------*/
        /** Contact label group name, use the labelGroupName when vertically
          aligned or the window is bootstrap xs/sm which is another stacking case. */
        scope.contactLabelGroupName = function () {
          return scope.isHorizontal && (WindowSize.isMD || WindowSize.isLG)
            ? scope.contactGroupName || mUniqueGroupName + 'h'
            : scope.labelGroupName();
        };

        /** Main/Address Section label group name. */
        scope.labelGroupName = function () {
          return scope.groupName || mUniqueGroupName;
        };

        /*-----------------------*/
        /* Phone Label Accessors */
        /*-----------------------*/
        scope.getPhone1Label = function () {
          return scope.phone1Label || 'Phone';
        };
        scope.getPhone2Label = function () {
          return scope.phone2Label || 'Alt. Phone';
        };

        /** Window resize event handler. Trigger a digest to update any expressions in the template. */
        function onResize() {
          scope.$digest();
        }

        /*--------------------*/
        /* Initialize element */
        /*--------------------*/
        element.addClass('csm-address');

        /*-----------------------------------------------*/
        /* Set up a watch for the horizontal orientation */
        /*-----------------------------------------------*/
        scope.$watch('orientation', function (orientation) {
          scope.isHorizontal = orientation == 'horizontal';
        });

        /*----------------------------------------*/
        /* Watch for disabled/readonly attributes */
        /*----------------------------------------*/
        scope.$watch(
          function () {
            return element[0].hasAttribute('disabled');
          },
          function (hasAttr) {
            scope.isDisabled = hasAttr;
          }
        );
        scope.$watch(
          function () {
            return element[0].hasAttribute('readonly');
          },
          function (hasAttr) {
            scope.isReadonly = hasAttr;
          }
        );

        /*------------------------------------------------------------*/
        /* Map flag attributes to scope properties. Default to false. */
        /*------------------------------------------------------------*/
        mFlagAttributes.forEach(function (fa) {
          scope[fa] = false;
          attr.$observe(fa, function () {
            scope[fa] = attr[fa] == 'true';
          });
        });

        /*---------------------------------------------------------*/
        /* Set up a window resize listener for expression updating */
        /*---------------------------------------------------------*/
        var $w = angular.element(window);
        $w.on('resize', onResize);

        /*---------*/
        /* Cleanup */
        /*---------*/
        scope.$on('$destroy', function () {
          $w.off('resize', onResize);
        });
      }
    };
  })
  .name;
